export default "__VITE_ASSET__CDn4DcBQ__"